import { AppOffers } from '@/services/appOffers/appOffers.types';
import { getFormatPriceByCurrency } from '@/UI/Utils/utils';
import { formatDiscountDays, uniqueTimeRange } from '@/utils/appOffers/appDiscount';

export interface OfferRow {
  key: string;
  value: string;
  detail: string;
}

type Translate = (key: string, values?: Record<string, string | number>) => string;

// Alliances first, then the business smart pricing.
export const buildOfferRows = (t: Translate, { alliances, smartPricing }: AppOffers): OfferRow[] => {
  const rows: OfferRow[] = alliances.map((alliance) => ({
    key: `campaign-${alliance.campaign}`,
    value: t('APP_OFFERS.ROW_PERCENTAGE', { value: alliance.percentage }),
    detail: t(alliance.detailKey),
  }));

  if (!smartPricing) {
    return rows;
  }

  const { discount, selectedServicesOnly, currencySymbol, delimiter } = smartPricing;

  const value =
    discount.valueType === 'fixed'
      ? getFormatPriceByCurrency(Math.round(discount.value), { unit: currencySymbol, delimiter, separator: ',' })
      : t(discount.isMax ? 'APP_OFFERS.ROW_UP_TO' : 'APP_OFFERS.ROW_PERCENTAGE', { value: discount.value });

  const dayNames = Array.from({ length: 7 }, (_, i) => t(`APP_OFFERS.DAYS.${i}`));
  const days = formatDiscountDays(discount.days, dayNames, t('APP_OFFERS.SCHEDULE_CONNECTOR'));
  const range = uniqueTimeRange(discount.timeRanges);

  rows.push({
    key: 'smart-pricing',
    value,
    detail: [
      days ? days.charAt(0).toUpperCase() + days.slice(1) : null,
      range ? t('APP_OFFERS.SCHEDULE_TIME', { start: range.startTime, end: range.endTime }) : null,
      selectedServicesOnly ? t('APP_OFFERS.SELECTED_SERVICES') : null,
    ]
      .filter(Boolean)
      .join(' · '),
  });

  return rows;
};
